import { gsap } from 'gsap';

export function fadeIn(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        targetEl.style.height = 'auto';
        // force opacity to 0
        targetEl.style.opacity = 0
        // tween to opacity 1
        gsap.to(targetEl, {
            display: 'block',
            opacity: 1,
            onComplete: resolve
        })
    })
}

export function fadeOut(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // tween to opacity 0
        targetEl.style.height = 'auto';
        targetEl.style.opacity = 1,
        gsap.to(targetEl, {
            opacity: 0,
            onComplete: () => {
                targetEl.style.display = "none";
                resolve();
            }
        })
    });
}